'use strict';
import moment from 'moment';
import { Base64Binary } from '../../lib/base64.js';

class OperationsController {
  /* @ngInject */
  constructor(OperationsService, VehiclesService, $scope, $q, FileSaver, Blob) {
    Object.assign(this, {
      OperationsService,
      VehiclesService,
      $scope,
      $q,
      FileSaver,
      Blob
    });

    this.query = {
      limit: 25,
      page: 1,
      where: {},
      order: 'createdAt DESC',
      include: [
        'operationType',
        'client',
        'holder',
        'vehicle',
        'agency',
        'creditor'
      ]
    };
    this.dateFrom = moment()
      .subtract(1, 'month')
      .toDate();
    this.dateTo = moment().toDate();
    //this.operations = $scope.$parent.$resolve.operations;
    this.getOperations();
    this.onPagination = () => {
      this.getOperations();
    };
    this.clientIds = null;
    this.archived = false;
  }

  export() {
    this.OperationsService.downloadExcel(this.getQueryOpts())
      .then(contents => {
        let data = Base64Binary.decode(contents);
        let blob = new this.Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        this.FileSaver.saveAs(blob, 'operaciones.xlsx');
      })
      .finally(() => {
        this.showDownloadSpin = false;
      });
  }

  getQueryOpts() {
    //Return a obj with query options
    let opts = JSON.parse(JSON.stringify(this.query));
    /*eslint-disable*/
    const wheres = [];
    switch (this.filter) {
      case 'all':
        break;

      case 'draft':
        wheres.push({
          status: 'draft'
        });
        break;

      case 'approved':
        wheres.push({
          status: 'approved'
        });
        break;
    }
    /*eslint-enable*/

    if (this.dateFrom) {
      wheres.push({
        createdAt: {
          gt: this.dateFrom
        }
      });
    }
    if (this.dateTo) {
      wheres.push({
        createdAt: {
          lte: this.dateTo
        }
      });
    }

    // Order translation
    if (this.mdOrder) {
      opts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    if (this.holderIds) {
      wheres.push({
        holderId: {
          inq: this.holderIds
        }
      });
    }

    if (this.clientIds) {
      wheres.push({
        clientId: { inq: this.clientIds }
      });
    }
    opts.where = wheres.length > 1 ? { and: wheres } : wheres;
    opts.deleted = this.archived;
    return opts;
  }

  getOperations() {
    let opts = this.getQueryOpts();

    let queryReady = this.OperationsService.getModels(opts).then(operations => {
      this.operations = operations;
    });
    let countReady = this.OperationsService.getCount(opts).then(result => {
      this.operationsCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }

  onClientFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.clientIds = clients ? clients.map(c => c.id) : null;
      this.getOperations();
    });
  }

  onHolderFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.holderIds = clients ? clients.map(c => c.id) : null;
      this.getOperations();
    });
  }

  getQuotes() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    // Order translation
    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    if (this.id) {
      this.holder = null;
      this.vehicle = null;
      this.procedureTemplate = null;
      qOpts.where = Object.assign(qOpts.where, {
        id: this.id
      });
    }

    if (this.holderIds) {
      qOpts.where = Object.assign(qOpts.where, {
        holderId: {
          inq: this.holderIds
        }
      });
    }

    if (this.clientIds) {
      qOpts.where = Object.assign(qOpts.where, {
        clientId: {
          inq: this.clientIds
        }
      });
    }

    if (this.vehicle) {
      Object.assign(qOpts.where, {
        vehicleId: this.vehicle.id
      });
    }

    if (this.procedureTemplate) {
      Object.assign(qOpts.where, {
        procedureName: this.procedureTemplate.name
      });
    }

    if (this.onlyApproved) {
      qOpts.where = Object.assign(qOpts.where, {
        approvedAt: {
          neq: null
        }
      });
    }

    if (this.pendingAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingAmount: {
          gte: this.pendingAmount
        }
      });
    }
    if (this.pendingReceiptsAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingCollectionAmount: {
          gte: this.pendingReceiptsAmount
        }
      });
    }
    if (this.pendingInvoicesAmount > 0) {
      qOpts.where = Object.assign(qOpts.where, {
        totalPendingInvoicesAmount: {
          gte: this.pendingInvoicesAmount
        }
      });
    }
    if (this.groupInvoiceStatus != 'all') {
      qOpts.where = Object.assign(qOpts.where, {
        groupInvoiceStatus: this.groupInvoiceStatus
      });
    }

    let queryReady = this.OperationsService.getModels(qOpts).then(
      operations => {
        this.operations = operations;
      }
    );
    let countReady = this.OperationsService.getCount(qOpts).then(result => {
      this.operationsCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }

  querySearchClient(text) {
    return this.ClientsService.find({
      filter: {
        where: {
          or: [
            {
              name: {
                ilike: `%${text}%`
              }
            },
            {
              lastName: {
                ilike: `%${text}%`
              }
            }
          ]
        },
        order: 'lastName DESC, name DESC'
      }
    });
  }

  queryVehicleSearch() {
    return this.VehiclesService.getModels({
      where: {
        broad: this.searchVehicleText
      },
      order: 'plate DESC, number DESC, description DESC'
    }).then(vehicles => {
      return vehicles.map(v => {
        v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return v;
      });
    });
  }
}

export default OperationsController;
